import gql from "graphql-tag";

export const PLACES_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        type
        placeId
        mainText
        secondaryText
      }
    }
  }
`;

export const QUESTIONARY_PARSAMS = gql`
  query sendAnswers(
    $address: AddressHash!
    $page: Int!
    $perPage: Int
    $sort: String!
    $filters: [SearchHash!]
  ) {
    properties(
      address: $address
      page: $page
      sort: $sort
      filters: $filters
      perPage: $perPage
    ) {
      entities {
        id
        score
        listPrice
        gAddress
        roomInfo
        coordinates
        city
        street
        photos {
          id
          image
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      address {
        placeId
        description
        type
        coordinates
      }
    }
  }
`;

export const SIGN_OUT = gql`
  mutation signOut {
    signOut {
      status
    }
  }
`;
